import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyEuro',
    standalone: true
})
export class CurrencyEuroPipe implements PipeTransform {
  /**
   * @param value           numero/stringa/null/undefined
   * @param forcePositive   se true rende il valore sempre positivo
   * @param emptyFallback   testo da mostrare quando il valore non è valido
   * @param showSymbol      se false non mostra il simbolo € (usa formato decimale a 2 cifre)
   */
  transform(
    value: number | string | null | undefined,
    forcePositive: boolean = false,
    emptyFallback: string = '-',
    showSymbol: boolean = true
  ): string {
    if (value === null || value === undefined || value === '') {
      return emptyFallback;
    }

    let n: number;
    if (typeof value === 'number') {
      n = value as number;
    } else {
      const raw = String(value).trim().replace(/\s+/g, '');
      const normalized = raw.replace(',', '.');
      n = Number(normalized);
    }

    if (!Number.isFinite(n)) {
      return emptyFallback;
    }

    if (forcePositive) n = Math.abs(n);
    if (Object.is(n, -0)) n = 0;

    if (showSymbol) {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);
    } else {
      return new Intl.NumberFormat('it-IT', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    }
  }
}
